import React, { useMemo } from "react";
import PropTypes from "prop-types";

import BlogPostCard from "./BlogPostCard";
import Carousel from "../Components/Carousel";

const RelatedPosts = ({
    posts
}) => {
    const postCards = useMemo(() => {
        return posts.length > 0
            ? posts.map((post, index) => (
                <BlogPostCard
                    key={`related-post-${index}`}
                    post={post}
                />
            ))
            : [];
    }, [posts]);

    return posts.length > 0
        ? (
            <Carousel
                items={postCards}
            />
        )
        : null;
};

RelatedPosts.propTypes = {
    posts: PropTypes.array
};

export default RelatedPosts;